import React from "react";
import { useParams } from "react-router";
import PatientActivityReport from "../../Shared/PatientActivityReport";

const AdminDoctorPatientReport = () => {
  const { id } = useParams();
  return (
    <PatientActivityReport
      userId={id}
      title="Patient Clinical Reports"
      description="Track patient visual training activities and therapy progress"
    />
  );
};

export default AdminDoctorPatientReport;
